import {NgIf} from '@angular/common';
import {CommonModule} from '@angular/common';
import {AfterViewInit, OnChanges, OnInit} from '@angular/core';
import {Component, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {finalize, tap} from "rxjs";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatFormFieldModule, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatAutocompleteModule, MatOption} from "@angular/material/autocomplete";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {ChangeDetectorRef} from '@angular/core';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { MatExpansionModule} from "@angular/material/expansion";
import { environment } from '../../../../environments/environment';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { AnalyseService } from '../../../services/analyse-service/analyse.service';
import { ClientsService } from '../../../services/client-service/clients.service';
import { HandleErrorsService } from '../../../services/handle-erros/handle.errors.service';
import { MatriceService } from '../../../services/matrice-service/matrice.service';
import { ParametreService } from '../../../services/parametre-service/parametre.service';
import { SampleStatusService } from '../../../services/sample-status-service/sample.status.service';
import { TerrrainService } from '../../../services/terrains-service/terrrain.service';
import { TypeAnalyseService } from '../../../services/type-analyse-service/type.analyse.service';
import { DialogService } from '../../_modal/dialog.service';
import { ApiService } from '../../_services/api.service';
import { Endpoints } from '../../endpoints';
import { MatChipsModule } from '@angular/material/chips';
import { ProductData } from '../../_models/typeSampleDTO';
import { SampleService } from '../../../services/sample-service/sample.service';
import { filter , map} from 'rxjs/operators';
import { MatriceDTO } from '../../_models/MatriceDTO';

@Component({
    selector: 'app-manage-matrice',
    standalone: true,
    providers: [TerrrainService,AnalyseService,SampleService, ParametreService, TypeAnalyseService, ApiService, Endpoints, DialogService, MatriceService, HandleErrorsService, ClientsService, SampleStatusService],
    imports: [MatExpansionModule,
    MatNativeDateModule,
    CommonModule,MatFormFieldModule, MatSelectModule,
    ReactiveFormsModule,
    MatCardModule, MatMenuModule,MatAutocompleteModule, MatButtonModule, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,
    MatSuffix, MatSortModule, MatInputModule, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox],
    templateUrl: './manage-matrice.component.html',
    styleUrl: './manage-matrice.component.scss'
})
export class ManageMatriceComponent  implements OnInit, OnChanges, AfterViewInit {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    form: FormGroup;
    searchVal: string = ''
    dataSource: MatTableDataSource<MatriceDTO> = new MatTableDataSource<MatriceDTO>();
    selectedMatrices: Set<MatriceDTO> = new Set<MatriceDTO>();
    isAllMatricesSelected: boolean = false

    displayedColumns: string[] = [
        //'id',
        'reference',
        'priseDEssai',
        'nom',
        'type',
        'matriceReglementaires',
        'description',
        'creationDate',
        'createdBy',
        'updateDate',    ];
    columns: string[] = [...this.displayedColumns];
    content: any;
    loadingTable: boolean = true;
    loadingOT: boolean = false
    loadingPdfGen: boolean = false
    loadingRapport: boolean = false
    loadingExcel: boolean = false
    panelOpenState = false;
    creatingUser = false;
    toastr: any;
    matriceReglementaires: any[] = [];
    filteredProducts: ProductData[] = [];
    productList: ProductData[] = [];
    types: string[] = [];

    ngOnInit() {
        this.fetchSampleList()
        this.getColsCookie()
        this.fetchProducts()
        this.sampleTypeControl.valueChanges
            .pipe(
            filter(() => this.autocompleteActivated),
            map(value => typeof value === 'string' ? value : ''),
            map(value => value ? this.filterProducts(value) : this.productList)
            )
            .subscribe(filtered => {
            this.filteredProducts = filtered;
            console.log('Produits filtrés :', filtered);
            });
          this.matriceService.getTypes().subscribe(data => {
                this.types = data;
            });
    }


    constructor(
        private cookieService: CookieService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        private sampleService:SampleService,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private matriceService: MatriceService,
        private handleErrors: HandleErrorsService) {
        this.initializeForm();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }
    fetchProducts() {
        this.sampleService.getAllProducts().subscribe({
            next: (products) => {
            console.log('Produits récupérés avec succès :', products);

            this.productList = products;
            this.filteredProducts = [];
            },
            error: (err) => {
            console.error('Erreur lors du chargement des produits', err);
            }
        });
}

    filterProducts(value: string): ProductData[] {
    const filterValue = value.toLowerCase();
    return this.productList.filter(product =>
        product.productName.toLowerCase().includes(filterValue)
    );
    }

    autocompleteActivated = false;
sampleTypeControl = new FormControl<ProductData | null>(null);

onInputFocus() {
  this.autocompleteActivated = true;
    console.log("Champ focus, activation de l'autocomplete");
}
displayProductName1(productId: any): string {
  if (!productId) return '';
  const product = this.filteredProducts.find(p => p.productId === productId);
  return product ? product.productName : '';
}
displayProductName(product: any): string {
  return product ? product.productName : '';
}

selectedMatriceReglementaireId: number | null = null;
onProductSelected(event: any) {
  const product = event.option.value as ProductData;

  console.log('Produit sélectionné =', product);

  // 🟢 نعمر autocomplete (يبقى الاسم ظاهر)
  this.sampleTypeControl.setValue(product);

  // 🟢 نعمر الفورم بـ productId فقط
  this.form.patchValue({
    matriceReglementaireIds: [product.productId]
  });

  console.log(
    'Form après sélection (productId):',
    this.form.value
  );
}


    initializeForm() {
        this.form = this.fb.group({
            id: [''],
            reference: [''],
            priseDEssai:[''],
            nom: [''],
            type: [''],
            description: [''],
            creationDate: [null],
            updateDate: [null],
            createdBy: [null, Validators.required],
            matriceReglementaireIds: [[]]

         });
    }
    
    ngAfterViewInit() {
        this.initializePaginatorAndSort()
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchVal
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';

    }

    editMatrice1(matrice: any) {
            console.log("Matrice sélectionnée pour modification :", matrice);
        
            this.form.patchValue({
                id: matrice.id,
                reference: matrice.reference,
                priseDEssai: matrice.priseDEssai,
                nom: matrice.nom,
                type: matrice.type,
                description: matrice.description,
                createdBy: matrice.createdBy?.username || 'N/A',
                matriceReglementaireIds:matrice.matriceReglementaireIds
            });
        
            console.log("Formulaire après patchValue :", this.form.value);
            this.modalService.open(this.editModal, { size: 'lg' });
        }
          
  saveUpdatedMatrice() {
  console.log("Formulaire de mise à jour soumis :", this.form.value);

  if (this.form.invalid) {
    console.error("Le formulaire est invalide", this.form.errors);
    return;
  }

  // Copier les valeurs du formulaire
  const updatedMatrice = { ...this.form.value };

  // Si createdBy est un string, le convertir en objet
  if (typeof updatedMatrice.createdBy === 'string') {
    updatedMatrice.createdBy = { username: updatedMatrice.createdBy };
  }

  // Convertir updateDate en string YYYY-MM-DD
  if (updatedMatrice.updateDate instanceof Date) {
    updatedMatrice.updateDate = updatedMatrice.updateDate.toISOString().split('T')[0];
  }

  // ⚡️ S'assurer que matriceReglementaireIds contient au moins les IDs existants
  if (!updatedMatrice.matriceReglementaireIds || updatedMatrice.matriceReglementaireIds.length === 0) {
    updatedMatrice.matriceReglementaireIds = this.matriceWithReglementaires.matriceReglementaires?.map((r: { productId: any; }) => r.productId) || [];
  }

  console.log("Matrice mise à jour à envoyer :", updatedMatrice);

  this.matriceService.updateMatrice(updatedMatrice.id, updatedMatrice).subscribe({
    next: (response) => {
      console.log("Réponse du backend :", response);
      if (response.status) {
        this.modalService.dismissAll();
        this.cdr.detectChanges();
        this.fetchSampleList(); 
      } else {
        console.error("Échec de la mise à jour :", response.message);
      }
    },
    error: (error) => {
      console.error("Erreur lors de la mise à jour de la matrice :", error);
    }
  });
}

    allReglementaires: any[] = [];    
 
matriceWithReglementaires: any; // variable pour stocker la matrice complète

openViewModel(matriceId: number) {
  this.matriceService.getMatriceWithReglementaires(matriceId).subscribe({
    next: (matrice) => {
      console.log('Matrice avec réglements:', matrice);

      this.matriceWithReglementaires = matrice; // <-- important pour le *ngFor

      if (this.form) {
        this.form.patchValue({
          id: matrice.id,
          nom: matrice.nom,
          type: matrice.type,
          reference: matrice.reference,
          priseDEssai:matrice.priseDEssai,
          description: matrice.description,
          createdBy: matrice.createdBy,
          creationDate: matrice.creationDate ? new Date(matrice.creationDate) : null,
          updateDate: matrice.updateDate ? new Date(matrice.updateDate) : null,
          matriceReglementaireIds: matrice.matriceReglementaires || []
        });
      }

      this.cdr.detectChanges();
      this.modalService.open(this.viewModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    },
    error: (err) => console.error('Erreur lors de la récupération de la matrice', err)
  });
}

openEditModal(matriceId: number) {

  console.log("Ouverture modal édition pour Matrice ID =", matriceId);

  this.matriceService.getMatriceWithReglementaires(matriceId).subscribe({
    next: (matrice) => {

      console.log("Matrice récupérée :", matrice);
      this.matriceWithReglementaires = matrice;

      this.sampleService.getAllProducts().subscribe({
        next: (products) => {

          this.filteredProducts = products;
          console.log("Liste de tous les produits disponibles :", this.filteredProducts);

          // Sélection du premier produit associé à la matrice
          const selectedProduct =
            matrice.matriceReglementaires?.length
              ? this.filteredProducts.find(
                  p => p.productId === matrice.matriceReglementaires[0].productId
                )
              : null;

          console.log("Produit sélectionné pour le formulaire :", selectedProduct);

          // Patch du formulaire
          this.form.patchValue({
            id: matrice.id,
            nom: matrice.nom,
            type: matrice.type,
            reference: matrice.reference,
            priseDEssai: matrice.priseDEssai,
            description: matrice.description,
            createdBy: matrice.createdBy?.username || 'N/A',
            creationDate: matrice.creationDate ? new Date(matrice.creationDate) : null,
            updateDate: matrice.updateDate ? new Date(matrice.updateDate) : null,
            // ⚡️ Toujours garder l'ID existant du produit même si l'utilisateur ne change rien
            matriceReglementaireIds: matrice.matriceReglementaires?.map(r => r.productId) || []
          });

          console.log("Form après patch :", this.form.value);

          // Mettre à jour le FormControl pour l'autocomplete
          if (selectedProduct) {
            this.sampleTypeControl.setValue(selectedProduct);
          } else {
            this.sampleTypeControl.setValue(null);
          }

          console.log("sampleTypeControl après setValue :", this.sampleTypeControl.value);

          this.cdr.detectChanges();
          this.modalService.open(this.editModal, { size: 'xl' });

          console.log("Modal ouvert avec taille xl.");
        },
        error: (err) => {
          console.error('Erreur lors de la récupération des produits', err);
        }
      });
    },
    error: (err) =>
      console.error('Erreur lors de la récupération de la matrice pour édition', err)
  });
}

         
    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open('Vous etes sur de supprimer ce matrice?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteMatrice(element.id);
                }
            });
    }

    deleteMatrice(id: number) {
        console.log("Suppression de la matrice avec l'id:", id); 

        this.matriceService.deleteMatrice(id).pipe(
            tap((response: any) => {
                if (response.status) {
                    this.removeTableRow(id);
                    this.dialogService.openSuceessAlert('Matrice supprimé avec succès' );
                }
            }),
            finalize(() => {
                this.dataSource.paginator = this.paginator;
            })
        ).subscribe();
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(sample => sample.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchVal
    }

    handleSelection(sam: MatriceDTO) {
        this.selectedMatrices.has(sam) ? this.selectedMatrices.delete(sam) : this.selectedMatrices.add(sam)
    }
    handleSelectAll() {
        this.isAllMatricesSelected = !this.isAllMatricesSelected;
        
        if (this.isAllMatricesSelected) {
            this.selectedMatrices = new Set<MatriceDTO>(this.dataSource.filteredData);
        } else {
            this.selectedMatrices = new Set<MatriceDTO>();
        }
    }
    
    openModal(content: any) {
        this.form.reset()
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
            (result) => {
                if (result === 'save') {
                }
            }
        );
    }
    
    saveMatrice() {
    const currentUser = sessionStorage.getItem('user_username') || 'N/A';
    console.log("Utilisateur authentifié récupéré :", currentUser);
    this.form.patchValue({ createdBy: { username: currentUser } });

    console.log("Formulaire après ajout de createdBy :", this.form.value);

    if (this.form.invalid) {
        console.error("Le formulaire n'est pas valide", this.form.errors);
        return;
    }

    const newMatrice = { ...this.form.value };

    console.log("Nouvelle matrice à envoyer:", newMatrice);

    this.matriceService.createMatrice(newMatrice).subscribe({
        next: (response) => {
            console.log("Réponse du backend:", response);
            if (response.status) {
                this.modalService.dismissAll(); 
                this.cdr.detectChanges(); 
                this.fetchSampleList(); 
            } else {
                console.error("Échec de la création de la matrice:", response.message);
                this.creatingUser = false;
                this.modalService.dismissAll(); 
                this.cdr.detectChanges(); 
                this.fetchSampleList(); 
            }
        },
        error: (error) => {
            console.error("Erreur lors de la création de la matrice:", error);
            this.creatingUser = false;
        }
    });
}

    
public fetchSampleList() {
    this.matriceService.getAllMatrices().subscribe({
        next: response => {
            console.log("Réponse API:", response); 
            if (response.status) {  
                // 🔹 Pré-calculer les noms des produits réglementaires
                const matricesWithProductNames = response.data.map((m: { matriceReglementaires: any[]; }) => ({
                    ...m,
                    matriceReglementaireNames: m.matriceReglementaires?.map((r: { productName: any; }) => r.productName).join(', ') || ''
                }));

                this.dataSource.data = matricesWithProductNames;  
            }
            this.loadingTable = false;
        },
        error: err => {
            this.handleErrors.catchError(err);
            this.loadingTable = false;
        }
    });
}


    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action']
    };

    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`matriceCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const sampleCols = this.cookieService.get(`matriceCol_${this.user_name}`); // Get the cookie value

        if (sampleCols) {
            this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', sampleCols);
        }
    }
    openImportModal(importModal: any) {
        this.modalService.open(importModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'})
    }
}
